const $t = vm.$t.bind(vm);
// 开始日期与结束日期的校验 开始日期不能大于结束日期
const checkStartEnd=function(rule, value, callback){
    if(!this.form.start || !this.form.end)
        return callback();
    
    if(this.form.start>this.form.end){
        return callback(new Error($t('integration.start_date_cannot_be_later_than_end_date')));
    }

    if(this.form.end < this.form.start){
        return callback(new Error($t('integration.end_date_cannot_be_earlier_than_start_date')));
    }
    callback();
}
// 因为这里需要拿到this 所以封装成一个函数
export const conditionRule = function(){
    return {
        start:[
            {required:true,message:$t('integration.please_enter_the_start_date')},
            {validator:checkStartEnd.bind(this)}
        ],
        end:[
            {required:true,message:$t($t('integration.please_enter_the_end_date'))},
            {validator:checkStartEnd.bind(this)}
        ],
        data:[
            {required:true,message:$t('integration.please_select_data')}
        ],
        file:[
            {required:true,message:$t('integration.please_select_a_file')}
        ]
    }
}